import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { LiftAndEscSvg, ActiveWheelChairSvg, InactiveWheelChairSvg, Lift, ESC } from '../../common/svg/AllSvg';

const LiftDetails = () => {
	const [data, setData] = useState<any[]>([])
	const stationDetailData: any = useSelector((state: any) => state.data.stationDetailData);
	const { t } = useTranslation('common');

	useEffect(() => {
		if (!!stationDetailData) {
			setData(stationDetailData?.lifts)
		}
	}, [stationDetailData])

	return (
		<>
			{/* Lifts and Escalators */}
			<div className=" w-full h-full mt-[30px] xlx:mt-[40px] bg-white dark:bg-bgDarkDull" id="lifts">
				<div className="lift-detail-top-bg bg-[#F6F9FC] h-[100px] dark:bg-[#0B121A] mb-[-1px]">
				</div>
				<div className="h-full w-full bg-[#F6F9FC] dark:bg-[#0B121A]">
					<div className="py-[30px] container flex items-center justify-center flex-col ">
						<div className="w-full msm:w-[900px]">
							<div className="flex items-center justify-start gap-[9px]">
								<LiftAndEscSvg />
								<h5 className='font-bold text-primaryText dark:text-white uppercase'>{t('passenger.station_detail.lift_and_escalator')}</h5>
							</div>

							<div className="overflow-x-auto mt-[25px]">
								<div className="inline-block min-w-full">
									<div className="overflow-hidden">
										<table className="min-w-full">
											<thead>
												<tr className="border border-[#0A2540] dark:border-[#E6E6E6] dark:border-opacity-[0.4] border-opacity-[0.15]">
													<th className="text-blackDark dark:text-textBlackDark font-bold text-base leading-snug px-[29px] py-[5px] text-left border-r border-[#0A2540] border-opacity-[0.15] dark:border-[#E6E6E6] dark:border-opacity-[0.4]">{t('passenger.station_detail.name')}</th>
													<th className="text-blackDark dark:text-textBlackDark font-bold text-base leading-snug px-[29px] py-[5px] text-left border-r border-[#0A2540] border-opacity-[0.15] dark:border-[#E6E6E6] dark:border-opacity-[0.4]">{t('passenger.station_detail.location')}</th>
													<th className="text-blackDark dark:text-textBlackDark font-bold text-base leading-snug px-[29px] py-[5px] text-center border-r border-[#0A2540] border-opacity-[0.15] dark:border-[#E6E6E6] dark:border-opacity-[0.4]">{t('passenger.station_detail.placement')}</th>
													<th className="text-blackDark dark:text-textBlackDark font-bold text-base leading-snug px-[29px] py-[5px] text-center">{t('passenger.station_detail.accessible')}</th>
												</tr>
											</thead>
											<tbody>
												{Array.isArray(data) && data.map((item: any, index: number) => (
													<tr className={`border border-[#0A2540] border-opacity-[0.15] dark:border-[#E6E6E6] dark:border-opacity-[0.4] min-h-[48px]`} key={index}>
														<td className="py-[14px] px-[29px] border-r border-[#0A2540] border-opacity-[0.15] dark:border-[#E6E6E6] dark:border-opacity-[0.4] relative">
															<div className="absolute top-0 left-[-1px] bottom-0 flex items-center justify-center">
																<div className="w-[1px] h-[12px] bg-primary "></div>
															</div>
															<div className="flex items-center gap-[10px]">
																{item?.lift_type?.toLowerCase() === "lift" ? <Lift /> : <ESC />}
																<h5 className="font-semibold text-blackDull dark:text-textBlackDull leading-snug">{item?.code}</h5>
															</div>
														</td>
														<td className="font-semibold text-blackDull dark:text-textBlackDull text-base leading-snug py-[14px] px-[29px] border-r border-[#0A2540] border-opacity-[0.15] dark:border-[#E6E6E6] dark:border-opacity-[0.4]">{item?.description_location}</td>
														<td className="font-semibold text-blackDull dark:text-textBlackDull text-base leading-snug py-[14px] px-[29px] text-center border-r border-[#0A2540] border-opacity-[0.15] dark:border-[#E6E6E6] dark:border-opacity-[0.4] capitalize">{item?.available_outside_inside}</td>
														<td className="py-[14px] px-[29px]">
															<div className="flex items-center justify-center gap-[5px]">
																{item.divyang_friendly ? <ActiveWheelChairSvg /> : <InactiveWheelChairSvg />}
																<p className={`${item.divyang_friendly ? "text-primary" : "text-blackDull dark:text-textBlackDull"} font-semibold`}> {item?.divyang_friendly ? t("passenger.station_detail.yes") : t("passenger.station_detail.no")}</p>
															</div>
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="lift-detail-bottom-bg bg-[#F6F9FC] dark:bg-[#0B121A] h-[100px]">
				</div>
			</div>
		</>
	);
};

export default LiftDetails;